var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import './style.css';
var DIVIDER = '|';
var TOOL_TYPE = {
    BUTTON: 'button',
    DIVIDER: 'divider',
    DROPDOWN: 'dropdown',
    SELECT: 'select',
    COLOR: 'color',
    CUSTOM: 'custom',
    MORE: 'more',
};
var ToolbarLib = /** @class */ (function () {
    function ToolbarLib(props) {
        this.contents = [];
        var editor = props.editor, option = props.option;
        this.editor = editor;
        this.option = option;
        this.getTools();
    }
    ToolbarLib.prototype.unmount = function () { };
    ToolbarLib.prototype.getTools = function () {
        var _this = this;
        if (this.option.tools) {
            this.contents = this.option.tools
                .map(function (toolName) { return _this.formatTools(toolName); })
                .filter(function (t) { return t; });
        }
    };
    ToolbarLib.prototype.formatTools = function (toolName) {
        if (Array.isArray(toolName)) {
            return this.buildMoreTools({ content: toolName });
        }
        else if (typeof toolName === 'object') {
            if ('render' in toolName) {
                var tooltip = toolName.tooltip, render = toolName.render, name_1 = toolName.name;
                return { name: name_1, tooltip: tooltip, type: TOOL_TYPE.CUSTOM, render: render };
            }
            else if ('content' in toolName) {
                return this.buildMoreTools(toolName);
            }
        }
        else if (typeof toolName === 'string') {
            if (toolName === DIVIDER) {
                return { type: TOOL_TYPE.DIVIDER };
            }
            else {
                var pluginConfig = this.getSylPluginConfigByName(toolName);
                if (pluginConfig && pluginConfig.toolbar) {
                    return this.buildButtonTool(toolName, pluginConfig);
                }
            }
        }
    };
    ToolbarLib.prototype.getSylPluginConfigByName = function (name) {
        return this.editor.configurator
            .getSylPlugins()
            .map(function (p) {
            if (!p.$controller)
                return;
            return {
                name: p.name || p.$controller.name,
                toolbar: p.$controller.toolbar,
                disable: p.$controller.disable,
                active: p.$controller.active,
            };
        })
            .find(function (p) { return p && p.name === name; });
    };
    ToolbarLib.prototype.buildMoreTools = function (config) {
        var _this = this;
        var _a = config.name, name = _a === void 0 ? '' : _a, _b = config.tooltip, tooltip = _b === void 0 ? '' : _b, content = config.content, _c = config.icon, icon = _c === void 0 ? '' : _c, _d = config.trigger, trigger = _d === void 0 ? 'hover' : _d, rest = __rest(config, ["name", "tooltip", "content", "icon", "trigger"]);
        return __assign(__assign({}, rest), { name: name, icon: icon, tooltip: tooltip, trigger: trigger, type: TOOL_TYPE.MORE, content: content.map(function (n) { return _this.formatTools(n); }).filter(function (t) { return t; }) });
    };
    ToolbarLib.prototype.buildButtonTool = function (toolName, pluginConfig) {
        var toolbar = pluginConfig.toolbar, name = pluginConfig.name, disable = pluginConfig.disable, active = pluginConfig.active;
        var _a = this.option, _b = _a.tooltips, tooltips = _b === void 0 ? {} : _b, _c = _a.icons, icons = _c === void 0 ? {} : _c, _d = _a.showNames, showNames = _d === void 0 ? {} : _d;
        var showName = showNames[toolName];
        return {
            type: toolbar.type || TOOL_TYPE.BUTTON,
            name: name,
            tooltip: tooltips ? tooltips[toolName] : false,
            showName: showName,
            toolbar: __assign(__assign({}, toolbar), { disable: disable, active: active, icon: icons[toolName] || toolbar.icon }),
        };
    };
    return ToolbarLib;
}());
export { TOOL_TYPE, ToolbarLib, };
export * from './loader';
//# sourceMappingURL=index.js.map